import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import creditCardImage from '../../../../../public/static/books/credit-card.png';
import PurchaseOutlineLabel from './labels/PurchaseOutlineLabel';

import css from './PurchaseLabeledContainer.module.scss';

interface Props extends React.HtmlHTMLAttributes<HTMLDivElement> {
  contentsPadding?: boolean;
  creditCardLabel?: boolean;
  description?: string;
  errorStyle?: boolean;
  label: string;
  paddingTop?: boolean;
  requiredLabel?: boolean;
  noBorderBottom?: boolean;
}

const PurchaseLabeledContainer = ({
  className,
  children,
  contentsPadding,
  creditCardLabel,
  description,
  errorStyle,
  intl,
  label,
  paddingTop,
  requiredLabel,
  noBorderBottom,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.PurchaseLabeledContainer, className);
  const labelclasses = classNames(css.PurchaseLabeledContainer__Label, {
    [css.isCreditCard]: creditCardLabel,
    [css.isRequired]: requiredLabel,
    [css.withPaddingTop]: paddingTop,
  });
  const contentsClasses = classNames(css.PurchaseLabeledContainer__Contents, {
    [css.withContentsPadding]: contentsPadding,
    [css.isError]: errorStyle,
    [css.noBorderBottom]: noBorderBottom,
  });

  return (
    <div className={classes}>
      <div className={labelclasses}>
        <div className={css.PurchaseLabeledContainer__LabelInner}>
          {label}
          {requiredLabel && (
            <PurchaseOutlineLabel
              className={css.PurchaseLabeledContainer__Required}
              label={intl.formatMessage({
                id: 'purchases.purchaseLabeledContainer.required',
              })}
            />
          )}
          {creditCardLabel && (
            <img
              className={css.PurchaseLabeledContainer__CreditCard}
              src={creditCardImage}
              alt="VISA, Mastercard, American Express"
            />
          )}
        </div>
        {description && (
          <span className={css.PurchaseLabeledContainer__Description}>
            {description}
          </span>
        )}
      </div>
      <div className={contentsClasses}>{children}</div>
    </div>
  );
};

export default injectIntl(PurchaseLabeledContainer);
